import { FC } from 'react';

import { EntityRole, entityRole } from '@/api/entity/types';
import { TeamAssociateStatus, TeamAssociateStatusType } from '@/api/types';
import { Drawer, Select } from '@/shared/design-system';

import { FiltersDrawerBody, FiltersField } from './user-details.styled';

export interface IUserDetailsFilters {
  search: string;
  role: EntityRole | '';
  status: TeamAssociateStatusType | '';
}

export type UserDetailsFilterValues = Pick<IUserDetailsFilters, 'role' | 'status'>;

const humanizeKey = (key: string) =>
  key
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim();

const roleOptions = Object.keys(entityRole).map((role) => ({ value: role, label: role }));

const statusOptions = Object.entries(TeamAssociateStatus).map(([key, label]) => ({
  value: key,
  label: label || humanizeKey(key),
}));

export const countActiveFilters = ({ role, status }: UserDetailsFilterValues) =>
  [role, status].filter(Boolean).length;

type UserDetailsFiltersDrawerProps = {
  open: boolean;
  value: UserDetailsFilterValues;
  onClose: () => void;
  onChange: (_value: UserDetailsFilterValues) => void;
};

export const UserDetailsFiltersDrawer: FC<UserDetailsFiltersDrawerProps> = ({
  open,
  value,
  onClose,
  onChange,
}) => (
  <Drawer
    open={open}
    onOpenChange={(next) => !next && onClose()}
    title="Filter by"
    showClose
    maxWidth={400}
    leftAction={{
      children: 'Reset',
      variant: 'ghost',
      color: 'tertiary',
      onClick: () => onChange({ role: '', status: '' }),
    }}
    primaryAction={{ children: 'Apply', onClick: onClose }}
  >
    <FiltersDrawerBody>
      <FiltersField>
        <Select
          size="lg"
          label="Role"
          placeholder="Filter by Role"
          options={roleOptions}
          value={value.role || null}
          onChange={(role) => onChange({ ...value, role: role as EntityRole | '' })}
        />
      </FiltersField>

      <FiltersField>
        <Select
          size="lg"
          label="Status"
          placeholder="Filter by Status"
          options={statusOptions}
          value={value.status || null}
          onChange={(status) =>
            onChange({ ...value, status: status as TeamAssociateStatusType | '' })
          }
        />
      </FiltersField>
    </FiltersDrawerBody>
  </Drawer>
);
